import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

export default function InputMaskSSN(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  const handleKeyDown = (event) => {
    if (event.key.length === 1 && !/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      mask="***-**-****"
      onChange={onChange}
      maskChar=""
      formatChars={{"*": "[0-9]*"}}
      onKeyDown={handleKeyDown}
    />
  );
}

InputMaskSSN.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskSSN.js